module.exports = __webpack_public_path__ + "static/Pikete-13b696335c0d659079c827ff07d28dd9.png";